import React from 'react';
import { Create, SimpleForm, TextInput, BooleanInput, required } from 'react-admin';
import { Box, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { ColorPickerInput } from '../../components/ColorPickerInput';

export const CustomerTypeCreate = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box
          component="button"
          onClick={() => navigate('/crm/customer-types')}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            border: '1px solid #ddd',
            borderRadius: 1,
            px: 2,
            py: 1,
            bgcolor: 'background.paper',
            cursor: 'pointer',
            '&:hover': {
              bgcolor: 'grey.100',
            },
            transition: 'all 0.2s ease',
          }}
        >
          <ArrowBackIcon fontSize="small" />
          <Typography variant="body2">Back to Customer Types</Typography>
        </Box>
      </Box>

      <Create redirect="list">
        <SimpleForm>
          <TextInput source="name" label="Name" validate={required()} fullWidth />
          <TextInput source="description" label="Description" multiline rows={2} fullWidth />
          <ColorPickerInput
            source="color"
            label="Color"
            helperText="Select a color for this customer type"
          />
          <BooleanInput source="isActive" label="Active" defaultValue={true} />
        </SimpleForm>
      </Create>
    </Box>
  );
};
